module.exports = __webpack_public_path__ + "img/arrow_return_b.ce7c43c7.svg";